import { TeamMemberRequestBody } from "@/shared/api-contract/api-contract";

export const DAY_IN_MILLS = 86400000;

export const EMAIL_REG = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const EMPTY_TEAM_MEMBER_BODY: TeamMemberRequestBody = {
    firstname: "",
    lastname: "",
    email: "",
    id_language: null,
    id_role: null,
    id_company: null,
    marketing_subscription: false,
};

export const BRAND_LABELS = {
    carconnex: "Carconnex",
    astara: "Astara",
};
